module.exports = __webpack_public_path__ + "img/centre_laval.4a83cab0.webp";